import React, { useCallback, useState } from 'react';
import { Button } from '../button';
import Modal from 'react-modal';
import {
  NSB_SKYPOD_MONTHLY_AND_ONEOFF_FEE_ON_US,
  productSkuIds,
  productStoreApi,
  useAnalytics,
  useCouponStore,
  useCustomerStore,
  useHandleRemove,
  useOrderStore,
  useProductStore,
  VoucherEvent,
} from '@sky-tv-group/shared';
import { T_PromoCodeRemovalModal } from './promoCodeTypes';
import { T_OrderRequest, T_Voucher } from '@sky-tv-group/shared';
import { WarningIcon } from '../icon';
import { Loader } from '../loader';

export function PromoCodeRemovalModal({ konakartService }: T_PromoCodeRemovalModal) {
  const [isLoading, setIsLoading] = useState(false);
  const { trackEvent } = useAnalytics();

  const {
    removeAllCoupons,
    clearPromoCodeVoucher,
    applyMultipleCouponsToStore,
    coupons,
    getSplitCoupons,
    voucher,
    setPromoCodeVoucher,
    clearPreviousStateCoupons,
    pCoupons,
    ctCoupons,
  } = useCouponStore();
  const { updateOrder, order } = useOrderStore();
  const { changeProductQuantity } = useProductStore();
  const handleRemove = useHandleRemove(konakartService);

  const { customerId } = useCustomerStore(s => ({
    customerId: s.kk,
  }));

  let cartProducts =
    voucher?.voucherProductId || voucher?.selectedBBProductId
      ? order?.orderProducts?.filter(
          p => !voucher?.voucherProductId?.includes(p.productId) && !voucher?.selectedBBProductId?.includes(p.productId)
        )
      : order?.orderProducts;
  let orderRequest: T_OrderRequest[] | any =
    cartProducts && cartProducts.length > 0
      ? cartProducts?.map(p => {
          return {
            productId: p.productId,
            quantity: p.quantity,
            finalPriceIncTax: p.finalPriceIncTax,
            downgrade: p.downgrade ?? false,
            inPromotion: p.inPromotion,
            currentlySubscribed: false,
            occurrenceNumber: p.occurrenceNumber,
            broadbandPriceHold: p.broadbandPriceHold,
            isPhantom: p.isPhantom,
          };
        })
      : [];
  const isBundle = JSON.parse(sessionStorage.getItem('isBundle') as any);

  const handlePromoCodeRemoval = async () => {
    try {
      removeAllCoupons();
      setIsLoading(true);

      const { bbCoupon: previousBBCoupon } = getSplitCoupons(pCoupons); // Split Existing Coupons to get DTH coupon if exists
      const previousBBCouponCodes = previousBBCoupon?.map(c => c.couponCode) ?? [];
      let previousCoupons = voucher?.selectedBBProductId
        ? pCoupons.filter(c => !previousBBCouponCodes.includes(c?.couponCode))
        : pCoupons;
      if (isBundle) {
        const hasSkyBoxorPod = order?.orderProducts?.find(
          p => p.product.sku === productSkuIds?.arrowBox?.primary || p.product.sku === productSkuIds?.skyPod?.primary
        );
        const has04998PreviousState = pCoupons?.find(cp =>
          cp.couponCode.includes(NSB_SKYPOD_MONTHLY_AND_ONEOFF_FEE_ON_US)
        );
        if (!has04998PreviousState) {
          let has04998 = hasSkyBoxorPod && (await konakartService.getCoupon(NSB_SKYPOD_MONTHLY_AND_ONEOFF_FEE_ON_US));
          if (has04998) {
            previousCoupons.push(has04998);
          }
        }
      }
      //removing voucher product Id in product store
      voucher?.voucherProductId?.forEach(id => {
        changeProductQuantity(id, -1, false);
      });

      await updateOrder(
        konakartService,
        customerId,
        orderRequest,
        previousCoupons,
        undefined,
        ctCoupons,
        productStoreApi.getState()?.products
      );
      await applyMultipleCouponsToStore([...previousCoupons]);
      let cartBBProducts =
        voucher?.selectedBBProductId &&
        order?.orderProducts?.find(p => voucher?.selectedBBProductId?.includes(p.productId))?.product;
      cartBBProducts && (await handleRemove(cartBBProducts));
      setPromoCodeVoucher({ ...voucher, isRemovalModal: false, selectedBBProductId: null } as T_Voucher);
      clearPreviousStateCoupons();
      clearPromoCodeVoucher();
      trackEvent(VoucherEvent.voucher_remove_clicked, {
        voucherCoupon: voucher?.coupon,
        voucherCode: voucher?.voucherCode,
      });
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.error(err);
    }
  };
  return (
    <div>
      {voucher?.isRemovalModal && (
        <Modal isOpen={voucher?.isRemovalModal} className={'promoCodeVoucherModal'}>
          <div className="rounded-xs lg:p-5 md:p-5 p-2" id="overlay">
            <div className="lg:sky-h5-reg md:sky-h5-reg sky-h3-reg font-black pb-2">
              <WarningIcon className={'inline mr-2'} />
              Are you sure?
            </div>
            <p className="sky-h4-reg pb-6">If you remove this, your discount will be lost.</p>
            <div className="lg:flex md:flex block lg:gap-4 md:gap-4">
              <div className="pb-4 lg:pb-0 md:pb-0 text-center lg:text-left md:text-left">
                <button
                  disabled={isLoading}
                  className={`sky-button sky-button--primary-pure ${isLoading && 'lg:p-6 md:p-6 p-8'} w-full`}
                  id="removal-voucher"
                  onClick={handlePromoCodeRemoval}>
                  {isLoading ? (
                    <div className="relative">
                      <Loader bgColor=""></Loader>
                    </div>
                  ) : (
                    'Continue'
                  )}
                </button>
              </div>
              <div className="text-center lg:text-left md:text-left">
                <Button
                  variant="secondary"
                  className="w-full"
                  disabled={isLoading}
                  colorMode="pure"
                  id="removePromoCode"
                  onClick={e => setPromoCodeVoucher({ ...voucher, isRemovalModal: false } as T_Voucher)}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
